export const parseTeams = (teams) => {
  if (Array.isArray(teams)) {
    return teams.map((team) => (team?.uuid ? team.uuid : team?.teamId || team?.id))
  } else {
    return [teams?.uuid ? teams.uuid : teams?.teamId || teams?.id]
  }
}
